import React from 'react';

import {
    Card,
    Col,
    Row,
    Container,
} from "reactstrap";

import SocialLinks from "../components/SocialLinks";

const GithubProfileCard = ({prof}) => {
    return ( 
            <Card className="section-lg bg-gradient-info shadow-lg border-0">
                <Container className="">
                <div className="p-2">
                  <Row className="">
                  <Col className="order-lg-2" lg="4">
                      <img src={prof.avatar_url} style={{width: "200px"}} alt="" className="rounded-circle img-center img-fluid shadow shadow-lg--hover mb-4"/>
                    </Col>
                    <Col lg="8" className="order-lg-1">
                      <h2 className="text-white">
                        Reach Out to Me!
                      </h2>
                      <p className="lead text-white mt-3">
                        DISCUSS AN OPEN SOURCE PROJECT , FULL-TIME OPPORTUNITY OR JUST WANT TO SAY HI? MY INBOX IS OPEN FOR ALL
                      </p>
                      <p className="text-white mt-3">
                          {prof.bio}
                      </p>
                      <a href="mailto:suthar.p@northeastern.edu">
                        <div className="my-3 icon-shape bg-gradient-white shadow rounded text-info">
                          <i className="ni ni-email-83 text-info mr-2" />                        
                          Contact Me
                        </div>
                      </a>
                      <p>
                        <a href="https://goo.gl/maps/9fFtvLbdHWr78rem8" target="_blank">
                        <div className="my-3 icon-shape bg-gradient-white shadow rounded text-info">
                          <i className="ni ni-pin-3 text-info mr-2" />                        
                          <strong>Boston, MA, US</strong>
                        </div>
                        </a>
                      </p>                      
                        <SocialLinks />
                    </Col>                    
                  </Row>
                </div>
                </Container>
              </Card>
     );
}
 
export default GithubProfileCard;